import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'

import '@progress/kendo-theme-default/dist/all.css'
import './index.css'
import 'react-datepicker/dist/react-datepicker.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
